"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNodes = void 0;
function getNodes(trees) {
    const nodes = [];
    for (const tree of trees) {
        getNodesSS(nodes, tree);
    }
    return nodes;
}
exports.getNodes = getNodes;
function getNodesSS(nodes, currentBranch) {
    nodes.push(currentBranch);
    for (const child of currentBranch?.children || []) {
        getNodesSS(nodes, child);
    }
}
//# sourceMappingURL=getNodes.js.map